// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  gap: 5px;
}

input {
  flex: none;
}

legend {
  font-size: 1rem;
}

.label-wrap {
  text-wrap: wrap;
  width: 180px;
}

.form-label.required {
  word-break: keep-all;
}

.form-label.required-true:after {
  color: #d11600;
  content: " *";
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoZWNrYm94LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGdCQUFnQjtBQUFoQjtFQUNFLFFBQUE7QUFFRjs7QUFDQTtFQUNFLFVBQUE7QUFFRjs7QUFDQTtFQUNFLGVBQUE7QUFFRjs7QUFDQTtFQUNFLGVBQUE7RUFDQSxZQUFBO0FBRUY7O0FBQ0E7RUFDRSxvQkFBQTtBQUVGOztBQUNBO0VBQ0UsY0FBQTtFQUNBLGFBQUE7QUFFRiIsImZpbGUiOiJjaGVja2JveC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZ2FwOiA1cHg7IC8vIGlmIGZsZXggZGlzcGxheSBhZGQgZ2FwXG59XG5cbmlucHV0IHtcbiAgZmxleDogbm9uZTtcbn1cblxubGVnZW5kIHtcbiAgZm9udC1zaXplOiAxcmVtO1xufVxuXG4ubGFiZWwtd3JhcCB7XG4gIHRleHQtd3JhcDogd3JhcDtcbiAgd2lkdGg6IDE4MHB4O1xufVxuXG4uZm9ybS1sYWJlbC5yZXF1aXJlZCB7XG4gIHdvcmQtYnJlYWs6IGtlZXAtYWxsO1xufVxuXG4uZm9ybS1sYWJlbC5yZXF1aXJlZC10cnVlOmFmdGVyIHtcbiAgY29sb3I6ICNkMTE2MDA7XG4gIGNvbnRlbnQ6ICdcXDAwYTAqJztcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/form-components/checkbox/checkbox.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,QAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,eAAA;EACA,YAAA;AAEF;;AACA;EACE,oBAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;AAEF;AACA,o1BAAo1B","sourcesContent":[":host {\n  gap: 5px; // if flex display add gap\n}\n\ninput {\n  flex: none;\n}\n\nlegend {\n  font-size: 1rem;\n}\n\n.label-wrap {\n  text-wrap: wrap;\n  width: 180px;\n}\n\n.form-label.required {\n  word-break: keep-all;\n}\n\n.form-label.required-true:after {\n  color: #d11600;\n  content: '\\00a0*';\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
